import React from 'react'
import '../CSS/Loader.css';

const Loader = () => {
    return (
        <div className="loader-container">
            <span className="loader-spinner" role="status" aria-label="Loading" />
        </div>
    )
}

export default Loader
